import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../contexts/userContext";
import { getUnit } from "../../facades/UnitFacade";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import Unit from "../Unit";
import { Interweave, Node } from "interweave";
import Link from "@mui/material/Link";
import useLiveLogging from "../../hooks/useLiveLogging";
import ReactPlayer from "react-player";
import ReactPlayerLoader from "@brightcove/react-player-loader";
import useExternalResources from "../../hooks/useExternalResources";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      sx={{ 
        pl: 3, 
        pr: 3, 
        pt: 0,
        width: '100%',
        maxWidth: '100%',
        overflow: 'hidden',
        boxSizing: 'border-box'
      }}
      {...other}
    >
      {value === index && (
        <Grid container sx={{ maxWidth: '100%' }}>
          <Grid item xs={12} sx={{ 
            maxWidth: '100%', 
            overflow: 'hidden',
            '& iframe': {
              maxWidth: '100%',
              height: 'auto'
            },
            '& img': {
              maxWidth: '100%',
              height: 'auto'
            }
          }}>
            <Box sx={{ 
              maxWidth: '100%', 
              overflow: 'hidden',
              overflowWrap: 'break-word',
              wordWrap: 'break-word'
            }}>
              {children}
            </Box>
          </Grid>
        </Grid>
      )}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const TabPanels = ({ html, value, selected_unit }) => {
  const candidateAction = useLiveLogging();
  const transform = (node, children) => {
    if (node.tagName === "A") {
      return (
        <Link
          color="secondary"
          target={node.getAttribute("target")}
          rel={node.getAttribute("rel")}
          onClick={() => {
            candidateAction({
              component: "Unit: " + selected_unit,
              event: "Link Clicked: " + node.getAttribute("href"),
            });
            console.log("clicky clicky");
          }}
          href={node.getAttribute("href")}
        >
          {children}
        </Link>
      );
    }

    if (node.getAttribute("src")) {
      console.log(node.getAttribute("src").includes("players.brightcove.net"));
    }

    if (
      node.tagName === "IFRAME" &&
      node.getAttribute("src") &&
      !node.getAttribute("src").includes("players.brightcove.net")
    ) {
      return (
        <Box sx={{ 
          position: 'relative',
          width: '100%', 
          maxWidth: '100%',
          paddingTop: node.getAttribute("width") && node.getAttribute("height") 
            ? `${(parseFloat(node.getAttribute("height")) / parseFloat(node.getAttribute("width"))) * 100}%`
            : '56.25%', // 16:9 aspect ratio
          '& > div': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%'
          }
        }}>
          <ReactPlayer
            url={node.getAttribute("src")}
            controls
            width="100%"
            height="100%"
            config={{
              vimeo: {
                playerOptions: {
                  title: true,
                },
              },
            }}
          />
        </Box>
      );
    }

    if (
      node.tagName === "IFRAME" &&
      node.getAttribute("src") &&
      node.getAttribute("src").includes("players.brightcove.net")
    ) {
      var src = node.getAttribute("src").slice(31);
      var accountId = src.substring(0, src.indexOf("/"));
      var videoId = src.slice(src.lastIndexOf("=") + 1);

      return (
        <Box sx={{ 
          position: 'relative',
          width: '100%', 
          maxWidth: '100%',
          paddingTop: '56.25%', // 16:9 aspect ratio
          '& video, & iframe': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%'
          }
        }}>
          <ReactPlayerLoader accountId={accountId} videoId={videoId} />
        </Box>
      );
    }
  };

  if (typeof html !== "string") {
    return null;
  }

  const parser = new DOMParser();
  let unitDoc = parser.parseFromString(html, "text/html");
  let sections = unitDoc.getElementsByClassName("vc_tta-panel");
  let panels = Array.from(sections).map((section, index) => {
    return (
      <TabPanel key={index} value={value} index={index}>
        <Interweave content={section.innerHTML} transform={transform} />
      </TabPanel>
    );
  });

  return <>{panels} </>;
};

const WebinarTabs = ({ html, value, handleChange, getSectionHeader }) => {
  const parser = new DOMParser();
  let unitDoc = parser.parseFromString(html, "text/html");
  let sections = unitDoc.getElementsByClassName("vc_tta-tab");

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Tabs
      orientation={matches ? "vertical" : "horizontal"}
      variant="scrollable"
      value={value}
      onChange={handleChange}
      aria-label="Webinars"
      sx={{
        [theme.breakpoints.up("md")]: {
          borderRight: 1,
          borderColor: "divider",
        },
      }}
    >
      {Array.from(sections).map((section, index) => {
        return (
          <Tab
            sx={{
              "&.MuiButtonBase-root.MuiTab-root": {
                justifyContent: "start",
                fontSize: 12,
              },
            }}
            key={index}
            label={getSectionHeader(section)}
            {...a11yProps(index)}
          />
        );
      })}
    </Tabs>
  );
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

// const useStyles = makeStyles((theme) => ({
//   root: {
//     flexGrow: 1,
//     //backgroundColor: theme.palette.background.paper,
//     display: "flex",
//     height: "100%",
//   },
//   tabCard: {
//     marginBottom: 15,
//   },
//   tabs: {
//     [theme.breakpoints.up("md")]: {
//       borderRight: `1px solid ${theme.palette.divider}`,
//     },
//     // alignItems: "flex-start",
//     //display:"flex"
//   },
//   wrapper: {
//     ///alignItems: "baseline"
//   },
//   tabpanel: {
//     padding: "0 30px",
//     width: "100%",
//   },
//   flexContainerVertical: {
//     display: "flex",
//     alignItems: "flex-start",
//     borderRadius: "5px",
//   },
//   intro: {
//     marginBottom: 30,
//   },
//   tabLabel: {
//     fontSize: 13,
//     fontWeight: 500,
//     [theme.breakpoints.up("md")]: {
//       textAlign: "left",
//       paddingRight: theme.spacing(2),
//     },
//     paddingLeft: 5,
//   },
//   card: {
//     marginBottom: theme.spacing(2),
//   },
// }));
export default React.memo(function GetStartedUnit(props) {
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [currentUnit, setCurrentUnit] = useState({});
  const [hasGoPricing, setHasGoPricing] = useState(false);
  const userContext = useContext(UserContext);

// Go Pricing table resources
  const goPricingCSS = [
    `${process.env.REACT_APP_BASE_URL}/wp-content/plugins/go_pricing/assets/css/go_pricing_styles.css?ver=1779880227`,
    `${process.env.REACT_APP_BASE_URL}/wp-content/plugins/go_pricing/assets/css/go_pricing_skin_green.css?ver=1779880227`,
    `${process.env.REACT_APP_BASE_URL}/wp-content/plugins/go_pricing/assets/plugins/js/mediaelementjs/mediaelementplayer.min.css?ver=1779880227`,
    `${process.env.REACT_APP_BASE_URL}/wp-content/plugins/go_pricing/assets/plugins/js/mediaelementjs/skin/mediaelementplayer.css?ver=1779880227`
  ];
  // Important: jQuery must load BEFORE go_pricing_scripts, so order matters
  const goPricingJS = [
    `${process.env.REACT_APP_BASE_URL}/wp-content/plugins/enable-jquery-migrate-helper/js/jquery/jquery-1.12.4-wp.js?ver=1779880227`,
    `${process.env.REACT_APP_BASE_URL}/wp-content/plugins/go_pricing/assets/js/go_pricing_scripts.js?ver=1779880227`
  ];


  // Dynamically load go-pricing resources when needed
  useExternalResources(goPricingCSS, goPricingJS, hasGoPricing);

  useEffect(() => {
    let isMounted = true;
    getUnit(props.selected_unit, userContext.user.token)
      .then((result) => result.json())
      .then((unit) => {
        if (isMounted) {
          setCurrentUnit(unit.content);
          // Check if content contains go-pricing tables
          const containsGoPricing = unit.content && 
            (unit.content.includes('go-pricing') || 
             unit.content.includes('go_pricing'));
          setHasGoPricing(containsGoPricing);
        }
      });
    return () => {
      isMounted = false;
    };
  }, [props.selected_unit, userContext.user.token]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const htmlHasTabs = (html) => {
    const parser = new DOMParser();
    let unitDoc = parser.parseFromString(html, "text/html");
    let sections = unitDoc.getElementsByClassName("vc_tta-tab");

    if (sections.length === 0) return false;
    else return true;
  };

  const getSectionIntro = (html) => {
    const parser = new DOMParser();
    let unitDoc = parser.parseFromString(html, "text/html");
    let intro = unitDoc.querySelector(
      "div.wpb_content_element div.wpb_wrapper",
    );
    if (intro) return intro.innerHTML;
    else return null;
  };

  const getSectionHeader = (section) => {
    let headers = section.getElementsByClassName("vc_tta-title-text");
    if (headers) {
      return headers[0].innerHTML;
    } else return null;
  };

  let theUnit = null;
  if (htmlHasTabs(currentUnit))
    theUnit = (
      <div>
        <Typography
          component="div"
          dangerouslySetInnerHTML={{ __html: getSectionIntro(currentUnit) }}
        />
        <Card elevation={0} sx={{ marginBottom: theme.spacing(2), overflow: 'hidden' }}>
          <CardContent sx={{ overflow: 'hidden' }}>
            <Grid container direction="row" sx={{ maxWidth: '100%' }}>
              <Grid item xs={12} md={2}>
                <WebinarTabs
                  html={currentUnit}
                  value={value}
                  handleChange={handleChange}
                  getSectionHeader={getSectionHeader}
                />
              </Grid>
              <Grid item xs={12} md={10} sx={{ maxWidth: '100%', overflow: 'hidden' }}>
                <TabPanels
                  html={currentUnit}
                  value={value}
                  selected_unit={props.selected_unit}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
    );
  else
    theUnit = (
      <Unit selected_unit={props.selected_unit} unit_url={props.unit_url} />
    );

  return <div>{theUnit}</div>;
});
